package com.neurobs.ccab
import io.circe.{Decoder, DecodingFailure, Encoder}

import scala.util.Try

case class VersionNumber private (major: Int, minor: Int, build: Int) extends Ordered[VersionNumber] {
	import scala.math.Ordered.orderingToOrdered

	def compare(that: VersionNumber): Int = (this.major, this.minor, this.build) compare (that.major, that.minor, that.build)

	override def toString: String = f"$major.$minor%03d.$build%03d"
}

object VersionNumber {
	private def apply(major: Int, minor: Int, build: Int): VersionNumber = new VersionNumber(major, minor, build)

	def apply(s: String): Option[VersionNumber] = {
		val expr = raw"([1-9]\d*|0)\.(\d{3})\.(\d{3})".r
		s match {
			case expr(major, minor, build) =>
				val temp = Array(major, minor, build).map(_.toInt).filter(_ < 256)
				if (temp.length == 3) Some(new VersionNumber(temp(0), temp(1), temp(2)))
				else None
			case _ => None
		}
	}

	def zero: VersionNumber = new VersionNumber(0, 0, 0)

	val testStationSyncVersion2 = new VersionNumber(0, 5, 0)

	implicit val circeDecoder: Decoder[VersionNumber] = Decoder.decodeString.emapTry { str => Try(VersionNumber(str).get) }
	implicit val circeEncoder: Encoder[VersionNumber] = Encoder.encodeString.contramap(_.toString)
}
